import { takeLatest, put, call } from 'redux-saga/effects';
import { makePostRequest, makeGetRequest, makePutRequest, makeDeleteRequest } from '../services/axios';
import { scopesApi } from '../services/services';
import { loadAndAlertMsg } from '../utilities/utilities';
import { clientMsgs, ScopeMsgs } from '../utilities/static-data';
import ScopeActions from './scope-actions';
import ClientActions from '../client/client-actions';

export default function* scopeSaga() {
	yield takeLatest(ScopeActions.API_GET_SCOPES_DATA, getScopesData);
	yield takeLatest(ScopeActions.API_POST_SCOPE_DATA, postScopeData);
	yield takeLatest(ScopeActions.API_PUT_SCOPE_DATA, putScopeData);
	yield takeLatest(ScopeActions.API_GET_SCOPE_DATA, getScopeData);
	yield takeLatest(ScopeActions.API_DELETE_SCOPE_DATA, deleteScopeData);
	yield takeLatest(ScopeActions.API_GET_CLIENTS_LINK_TO_SCOPE, getClientsLinkToScope);
	yield takeLatest(ScopeActions.API_PUT_CLIENTS_LINK_TO_SCOPE, putClientsLinkToScope);
}
function* putClientsLinkToScope(action) {
	yield put({ type: ClientActions.FETCHING_DATA });
	try {
		const response = yield call(() => makePutRequest(scopesApi + '/' + action.payload.name + '/clients', action.payload.clients));
		yield put({ type: ScopeActions.API_PUT_CLIENTS_LINK_TO_SCOPE_SUCCESS, payload: response.data });
		yield put({ type: 'APP_SHOW_ALERT', payload: { type: 'success', message: ScopeMsgs.clientsLinkToScopeSuccess } });
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
	} catch (error) {
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
		yield* loadAndAlertMsg(error, ScopeMsgs.clientsLinkToScopeFailed, true);
	}
}

function* getClientsLinkToScope(action) {
	yield put({ type: ClientActions.FETCHING_DATA });
	try {
		const response = yield call(() => makeGetRequest(scopesApi + '/' + action.payload?.name + '/clients?loadAllClients=true'));
		if (action.payload?.scopeData) {
			let data = action.payload?.scopeData;
			let clientsData = response.data?._embedded?.clients ? response.data._embedded.clients : [];
			data.clients = clientsData.map(obj => obj.clientId);
			data.clientsRequested = true;
			yield put({ type: ScopeActions.API_GET_SCOPE_DATA_SUCCESS, payload: {} });
			yield put({ type: ScopeActions.API_GET_SCOPE_DATA_SUCCESS, payload: data });
		} else {
			yield put({ type: ScopeActions.API_GET_CLIENTS_LINK_TO_SCOPE_SUCCESS, payload: response.data });
		}

		yield put({ type: ClientActions.FETCHING_DATA_DONE });
	} catch (error) {
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
		if (!action.payload?.scopeData) {
			yield* loadAndAlertMsg(error, ScopeMsgs.getClientsToScopeFailed, true);
		}
	}
}

function* deleteScopeData(action) {
	yield put({ type: ClientActions.FETCHING_DATA });
	try {
		yield call(() => makeDeleteRequest(scopesApi + '/' + action.payload?.name));
		yield put({ type: 'APP_SHOW_ALERT', payload: { type: 'success', message: ScopeMsgs.deleteScopeSuccess } });
		const response = yield call(() => makeGetRequest(scopesApi));
		yield put({ type: ScopeActions.API_GET_SCOPES_DATA_SUCCESS, payload: response.data });
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
	} catch (error) {
		yield* loadAndAlertMsg(error, clientMsgs.unexpectedError);
	}
}

function* getScopesData() {
	yield put({ type: ClientActions.FETCHING_DATA });
	try {
		const response = yield call(() => makeGetRequest(scopesApi));

		yield put({ type: ScopeActions.API_GET_SCOPES_DATA_SUCCESS, payload: response.data });
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
	} catch (error) {
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
		yield* loadAndAlertMsg(error, clientMsgs.unexpectedError);
	}
}
function* getScopeData(action) {
	yield put({ type: ClientActions.FETCHING_DATA });
	try {
		const response = yield call(() => makeGetRequest(scopesApi + '/' + action.payload?.name));
		yield put({ type: ScopeActions.API_GET_SCOPE_DATA_SUCCESS, payload: response.data });
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
	} catch (error) {
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
		yield* loadAndAlertMsg(error, clientMsgs.unexpectedError);
	}
}

function* postScopeData(action) {
	yield put({ type: ClientActions.FETCHING_DATA });
	try {
		const response = yield call(() => makePostRequest(scopesApi, action.payload));
		yield put({ type: ScopeActions.API_POST_SCOPE_DATA_SUCCESS, payload: response.data });
		yield put({ type: 'APP_SHOW_ALERT', payload: { type: 'success', message: ScopeMsgs.addScopeSuccess } });
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
	} catch (error) {
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
		yield* loadAndAlertMsg(error, clientMsgs.unexpectedError);
	}
}

function* putScopeData(action) {
	yield put({ type: ClientActions.FETCHING_DATA });
	try {
		const response = yield call(() => makePutRequest(scopesApi + '/' + action.payload?.name, action.payload));
		yield put({ type: ScopeActions.API_PUT_SCOPE_DATA_SUCCESS, payload: response.data });
		yield put({ type: 'APP_SHOW_ALERT', payload: { type: 'success', message: ScopeMsgs.updateScopeSuccess } });
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
	} catch (error) {
		yield put({ type: ClientActions.FETCHING_DATA_DONE });
		yield* loadAndAlertMsg(error, clientMsgs.unexpectedError);
	}
}
